import { HiInformationCircle } from "react-icons/hi";
import { useAuthContext } from "auth/AuthProvider";
import Sidebar from "components/Sidebar/Sidebar";

const WorkspaceSidebar = () => {
  const { user } = useAuthContext();

  const items = [
    {
      path: `/dashboard/cworkspace`,
      label: "Workspace Info",
      icon: <HiInformationCircle className="h-5 w-5" />,
    },
  ];

  const isActiveItems = (itemPath: string) => {
    const currentPath = window.location.pathname;
    return currentPath === itemPath;
  };

  const ProfileSection = (
    <div className="flex flex-col items-center justify-center px-6 py-5">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-navy-700 dark:text-white">
          {user.current_workspace.name}
        </h3>
      </div>
    </div>
  );

  return (
    <Sidebar
      items={items}
      isActiveItems={isActiveItems}
      ProfileSection={ProfileSection}
    />
  );
};

export default WorkspaceSidebar;
